export enum WORKSPACE_PLAN {
  TRIAL = 'trial',
  BASIC = 'basic',
  ENTERPRISE = 'enterprise',
  DEMO = 'demo',
}
